import React, { Component } from 'react';
import { gsap } from 'gsap';
import ImageGrid from './filters/ImageGrid';
import AppContext from '../../contexts/AppContext';

import './ArtworksList.css';

const ELEMENT_ID = 'artworks-drawer-list-gallery';

const PREVENT_CLOSING_IDS = ['bts-member-message', ELEMENT_ID];

class ArtworksList extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isShown: false,
      scrollY: 0,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleDown = this.handleDown.bind(this);
  }

  handleDown(event) {
    const { isShown } = this.state;
    if (!isShown) {
      return;
    }
    let element = event.target;
    let isClosing = true;
    while (element.parentNode) {
      if (PREVENT_CLOSING_IDS.indexOf(element.id) !== -1) {
        isClosing = false;
        break;
      }
      element = element.parentNode;
    }
    if (isClosing) {
      this.closeList();
    }
  }

  handleScroll() {
    if (this.panelScrollElement) {
      this.setState({
        scrollY: this.panelScrollElement.scrollTop,
      });
    }
  }

  addListeners() {
    window.addEventListener('mousedown', this.handleDown);
    window.addEventListener('touchdown', this.handleDown);
  }

  removeListeners() {
    window.removeEventListener('mousedown', this.handleDown);
    window.removeEventListener('touchdown', this.handleDown);
  }

  toggleList() {
    const { isShown } = this.state;
    if (isShown) {
      this.closeList();
    } else {
      this.openList();
    }
  }

  openList() {
    this.setState({ isShown: true });
    this.removeListeners();
    gsap.to(this.panelElement, {
      x: 0,
      duration: 0.45,
      onComplete: () => {
        this.addListeners();
        this.handleScroll();
      },
    });
  }

  closeList() {
    const { onCloseHandler } = this.props;
    this.setState({ isShown: false });
    this.removeListeners();
    gsap.to(this.panelElement, { x: '-100%', duration: 0.45 });
    onCloseHandler();
  }

  render() {
    const { dictionnary } = this.context;
    const { onArtworkListItemHandler, loadedArtworks } = this.props;
    const { isShown, scrollY } = this.state;

    if (!loadedArtworks) {
      return <></>;
    }
    return (
      <>
        <div
          id={ELEMENT_ID}
          ref={(c) => this.panelElement = c}
          onScroll={this.handleScroll}
        >
          <div
            id={`${ELEMENT_ID}-grid`}
            ref={(c) => this.panelScrollElement = c}
            onScroll={this.handleScroll}
          >
            <ImageGrid
              cols={1}
              data={loadedArtworks}
              dataIndex={0}
              dragEnabled={false}
              isOpened={isShown}
              onItemClickHandler={(result) => {
                onArtworkListItemHandler(result);
              }}
              scrollY={scrollY}
            />
          </div>
          <button
            type="button"
            id={`${ELEMENT_ID}-toggle`}
            className="main-button"
            onClick={(e) => {
              e.stopPropagation();
              this.toggleList();
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {isShown
              ? dictionnary.get('common-close')
              : dictionnary.get('common-artworks-in')}
          </button>
        </div>
      </>
    );
  }
}

export default ArtworksList;
